import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaPaperPlane, FaUser, FaComment, FaCar, FaHeadset, FaShieldAlt, FaStar } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import './contactus.css';

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5
    }
  },
  hover: {
    scale: 1.05,
    y: -5,
    transition: {
      duration: 0.3
    }
  }
};

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const contactMethods = [
    {
      icon: <FaPhone />,
      title: "Call Us",
      details: "+94 77 732 4632",
      color: "#001f3f",
      link: "tel:+94777324632",
    },



    {
      icon: <FaEnvelope />,
      title: "Email Us",
      details: "info@innovativeprefab.lk",
      color: "#666666",
      link: "mailto:info@innovativeprefab.lk"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Visit Us",
      details: "No: 318/1, Colombo Road, Bokundara, Piliyandala, Sri Lanka",
      color: "#001f3f",
      link: "https://maps.app.goo.gl/GdWbegR1MHDf69MS7"
    }
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // EmailJS configuration
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        message: formData.message,
    
      };

      // Send email using EmailJS
      await emailjs.send(
        'service_78mpgog', // Replace with your EmailJS service ID
        'template_bp0172l', // Replace with your EmailJS template ID
        templateParams,
        'd8qBv8wcZq-NmjhSr' // Replace with your EmailJS public key
      );

      alert('Thank you for Contacting Us! We will contact you shortly.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending email:', error);
      alert('There was an error sending your message. Please try again or contact us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="alt-contact-us">
      {/* Header Section */}
      <section className="alt-contact-header">
        <div className="alt-container">
          <motion.div 
            className="alt-header-content"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
          >
            <motion.h1 
              className="alt-header-title"
              variants={itemVariants}
            >
              Contact Us <span className="alt-accent-text"></span>
            </motion.h1>
            <motion.p 
              className="alt-header-subtitle"
              variants={itemVariants}
            >
              We embrace the principals of continuous improvement in product 
              innovation, quality, reliability and good customer service. 
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="alt-main-content">
        <div className="alt-container">
          <div className="alt-content-grid">
            {/* Booking Form */}
            <motion.div 
              className="alt-booking-section"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={containerVariants}
            >
              <div className="alt-section-header">
                <motion.h2 variants={itemVariants}>Get Connected</motion.h2>
                <motion.p variants={itemVariants}>
                  Fill in your details and Get connected with Us.
                </motion.p>
              </div>

              <motion.div 
                className="alt-booking-form-container"
                variants={itemVariants}
              >
                <form className="alt-booking-form" onSubmit={handleSubmit}>
                  <div className="alt-form-grid">
                    <div className="alt-form-group">
                      <label className="alt-form-label">
                        <FaUser className="alt-label-icon" />
                        Name *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="alt-form-input"
                        required
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div className="alt-form-group">
                      <label className="alt-form-label">
                        <FaEnvelope className="alt-label-icon" />
                        Email Address *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="alt-form-input"
                        required
                        placeholder="Enter your email"
                      />
                    </div>

                    <div className="alt-form-group">
                      <label className="alt-form-label">
                        <FaPhone className="alt-label-icon" />
                        Phone Number *
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="alt-form-input"
                        required
                        placeholder="Enter your phone number"
                      />
                    </div>
   

                    <div className="alt-form-group alt-full-width">
                      <label className="alt-form-label">
                        <FaComment className="alt-label-icon" />
                       Message
                      </label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="alt-form-textarea"
                        rows="3"
                        placeholder="Message"
                      ></textarea>
                    </div>
                  </div>

                  <motion.button
                    type="submit"
                    className="alt-submit-button"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <div className="alt-spinner"></div>
                        Processing...
                      </>
                    ) : (
                      <>
                        <FaPaperPlane className="alt-btn-icon" />
                        Get Connected
                      </>
                    )}
                  </motion.button>
                </form>
              </motion.div>
            </motion.div>










            {/* Contact & Map Section */}


<div className="alt-sidebar-section">
  {/* Contact Methods */}
  <motion.div 
    className="alt-contact-methods"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    variants={containerVariants}
  >
    <h3 className="alt-sidebar-title">Quick Contact</h3>
    <div className="alt-contact-list">
      {contactMethods.map((method, index) => (
        <motion.div
          key={index}
          className="alt-contact-method"
          variants={itemVariants}
        >
          <a 
            href={method.link} 
            className="alt-contact-link"
            target={method.link.includes('http') ? '_blank' : '_self'}
            rel={method.link.includes('http') ? 'noopener noreferrer' : ''}
            style={{ 
              textDecoration: 'none', 
              color: 'inherit', 
              display: 'flex', 
              alignItems: 'center', 
              width: '100%',
              gap: '15px', /* This adds the gap */
              padding: '10px',
              borderRadius: '8px',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.backgroundColor = '#f8f9fa';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <div 
              className="alt-method-icon"
              style={{ backgroundColor: method.color }}
            >
              {method.icon}
            </div>
            <div className="alt-method-content">
              <h4>{method.title}</h4>
              <p>{method.details}</p>
            </div>
          </a>
        </motion.div>
      ))}
    </div>
  </motion.div>
</div>
</div>










          {/* Map Section - Now outside the grid with 1200px width */}
          <motion.div 
            className="alt-map-section-full"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
          >
            <div className="alt-map-container-full">
              <h3 className="alt-sidebar-title">Our Location</h3>
              <div className="alt-map-wrapper">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.63612259315!2d79.91452457564624!3d6.814036702170079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae24fa7efb93b2f%3A0x1ccb6eb83663fffb!2sInnovative%20Pre%20-%20Fab%20Technology!5e0!3m2!1sen!2slk!4v1766938235125!5m2!1sen!2slk"
                  width="100%" 
                  height="400" 
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Rentionz Cabs Location"
                ></iframe>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default ContactUs;